import React, { useContext } from "react"
import TableStyleContext from "../TableStyleContext"
import Checkbox from "../../../../mp-shared-components/generic-shared-components/components/Checkbox"
import TableCell from "./TableCell"

type Props = {
  selected: boolean
  onSelectAllRows?: (selectAll: boolean) => void
  className?: string
}

export const TableHeaderCheckboxCell: React.FC<Props> = ({
  className,
  onSelectAllRows,
  selected,
  ...rest
}) => {
  const { cx, classes } = useContext(TableStyleContext)

  return (
    <TableCell
      role="columnheader"
      className={cx(
        classes.tableCell,
        classes.headTableCell,
        classes.checkboxCell,
        className
      )}
      data-automation-id="data-table-head-checkbox-cell"
      {...rest}
    >
      <Checkbox
        checked={selected}
        onChange={e => onSelectAllRows?.(e.target.checked)}
        className={classes.checkbox}
        inputProps={{
          "aria-label": selected ? "Deselect all" : "Select all"
        }}
        data-automation-id="data-table-head-checkbox"
      />
    </TableCell>
  )
}
